import { render } from "./ChangeDisplayNameModal.vue?vue&type=template&id=02c8bda7"
import script from "./ChangeDisplayNameModal.vue?vue&type=script&lang=js"
export * from "./ChangeDisplayNameModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__